import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface KanbanStore {
  selectedKanbanId: string | null;
  setSelectedKanbanId: (kanbanId: string | null) => void;
  clearSelection: () => void;
}

export const useKanbanStore = create<KanbanStore>()(
  persist(
    (set) => ({
      selectedKanbanId: null,
      setSelectedKanbanId: (kanbanId) => set({ selectedKanbanId: kanbanId }),
      clearSelection: () => set({ selectedKanbanId: null }),
    }),
    {
      name: 'kanban-storage',
    }
  )
);
